import { api } from "aldoo-ra/API"
import { SubmitSupportTicket } from "aldoo-ra/Admin/CustomerSupport/api"

const hcAPI = api("help-center")

/**
 * Get the complete help center table of contents with language support
 */
export const GetHelpCenterTOC = async (language) => {
  const lang = language || getCurrentLanguage()
  return await hcAPI({ get_toc: { language: lang } })
}

/**
 * Get content by URL with language support
 */
export const GetContent = async (contentURL, language) => {
  const lang = language || getCurrentLanguage()
  return await hcAPI({ get_content: { contentURL, language: lang } })
}

/**
 * Get root categories with language support
 */
export const GetRootCategories = async (language) => {
  const lang = language || getCurrentLanguage()
  return await hcAPI({
    get_content: { contentURL: "/category/helpcenterroot", language: lang },
  })
}

/**
 * Get category by slug with language support
 */
export const GetCategory = async (slug, language) => {
  const lang = language || getCurrentLanguage()
  return await hcAPI({
    get_content: { contentURL: `/category/${slug}`, language: lang },
  })
}

/**
 * Get nested category by path with language support
 */
export const GetNestedCategory = async (categoryPath, language) => {
  const path = categoryPath.join("/")
  const lang = language || getCurrentLanguage()
  return await hcAPI({
    get_content: { contentURL: `/category/${path}`, language: lang },
  })
}

/**
 * Get article by slug with language support
 */
export const GetArticle = async (slug, language) => {
  const lang = language || getCurrentLanguage()
  return await hcAPI({
    get_content: { contentURL: `/article/${slug}`, language: lang },
  })
}

/**
 * Get article in a specific category with language support
 */
export const GetArticleInCategory = async (
  categoryPath,
  articleSlug,
  language
) => {
  if (Array.isArray(categoryPath)) {
    categoryPath = categoryPath.join("/")
  }
  if (categoryPath.startsWith("/")) {
    categoryPath = categoryPath.substring(1)
  }
  const lang = language || getCurrentLanguage()
  return await hcAPI({
    get_content: {
      contentURL: `/category/${categoryPath}/article/${articleSlug}`,
      language: lang,
    },
  })
}

/**
 * Search for articles by term with language support
 */
export const SearchArticles = async (term, language) => {
  const lang = language || getCurrentLanguage()
  return await hcAPI({ search: { term, language: lang } })
}

/**
 * Send a help center request (support ticket)
 */
export const SendHelpCenterRequest = async (payload) => {
  return await SubmitSupportTicket(payload)
}

const getCurrentLanguage = () => {
  try {
    const storedValue = localStorage.getItem("current-site-language")
    return storedValue ? storedValue.replace(/"/g, "") : "en"
  } catch {
    return "en"
  }
}

export default {
  GetContent,
  GetRootCategories,
  GetCategory,
  GetNestedCategory,
  GetArticle,
  GetArticleInCategory,
  SearchArticles,
  SendHelpCenterRequest,
  GetHelpCenterTOC,
}
